import React from 'react';
import UIComponent from 'components/UiComponent';
import EvaluationItem from './ListItem';
import config from 'root/../config';
import moduleConfig from '../../../moduleConfig';
import proceduresConfig from '../../../moduleConfig';
import AppContext from 'components/appContext';
import authService from 'services/authService';
import { withRouter} from 'components/Routing';
import MsgBox from 'sis_ui/modules/notifications';
import {useTranslation} from "react-i18next";

const ProceduresList = ({ filter, router }) => {
    const { navigate , location } = router;

    const {t} = useTranslation();
    const ignoreCacheLocalStorage = window.localStorage.getItem('evaluations-list-igonre-cache') == 'true';
    const ignoreCahe = !(location && location.pathname.indexOf(moduleConfig.map.PROCEDURE_EVALUATION_FORM.path) >= 0) || ignoreCacheLocalStorage;

    return (
        <AppContext.Consumer>
            {data => {
                return (
                    <React.Fragment>
                    { filter ? 
                        <UIComponent
                            component="highlight-wrapper"
                            keyword={filter ? filter.search.search_string : null}
                        >
                            <UIComponent
                                id="evaluations-list"
                                component="data-view"
                                mode="LIST"
                                url={config.apiAppUrl + proceduresConfig.APIs.getProcedures}
                                urlParams={{
                                    auth_token: authService.getToken(),
                                    user_role: data.userDetails.CURRENT_ROLE,
                                    filter: JSON.stringify(filter)
                                }}
                                itemComponent={EvaluationItem}
                                listCardHeight={150}
                                listCardMargin={"7px 15px"}
                                fetchMethod="POST"
                                
                                pullToRefresh
                                onScroll={(scrollValues) => { data.updateScrollValue(scrollValues.scrollTop) }}
                                refreshOnUrlParamsChange={authService.getToken() ? true : false}
                                requestIndexModifier={1}
                                cache
                                ignoreCache={ignoreCahe}
                                getPublicData={(publicData) => {
                                    window.addEventListener("orientationchange", function () {
                                        if (publicData.hasOwnProperty("recalculateRowHeights")) {
                                            setTimeout(() => {
                                                publicData.recalculateRowHeights();
                                            }, 50);
                                        }
                                    }, false);
                                }}
                                onItemClick={(event,data)=>{
                                    if (data.HAS_REQUIRED_EVAL == 'Y') {
                                        MsgBox.drawMessage('warning',t("lbl.COMPLETE_LINKED_EVALUATIONS","In order to view this evaluation please complete all linked evaluations."))
                                    } else {                                        
                                         navigate("/" + moduleConfig.map.PROCEDURE_EVALUATION_FORM.path + "/" + data.USER_FORM_ID);        
                                    }
                                }}
                                onLoad={()=>{
                                    window.localStorage.removeItem('evaluations-list-igonre-cache');
                                }}
                            />
                        </UIComponent>
                    : null }
                    </React.Fragment>
                )}
            }
        </AppContext.Consumer>
    )
}

export default withRouter(ProceduresList);